export default __webpack_public_path__ + "static/media/influencer-1.190cbf5a.png";